import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Aggregations, Filter } from '../filters';
import { FormGroup } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { EqualFilterComponent } from './equal/equal.component';
import { MatIconModule } from '@angular/material/icon';
import { RangeFilterComponent } from './range/range.component';
import { MultiSelectFilterComponent } from './multi-select/multi-select.component';

@Component({
  selector: 'cbre-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss'],
  imports: [CommonModule, MatIconModule, EqualFilterComponent, MultiSelectFilterComponent, RangeFilterComponent],
})
export class FilterComponent {
  @Input() filter: Filter = null;
  @Input() form: FormGroup<Record<string, any>> = new FormGroup({});
  @Input() aggregations: Aggregations = {};
  @Input() canRemoveFilter = false;
  @Input() showLabel = true;

  @Output() removeFilter = new EventEmitter();
  @Output() filterOptionChange = new EventEmitter<Filter>();
}
